module.exports = __webpack_public_path__ + "static/media/214x152_8 copy.7f9934d9.png";